export const CalculationType = {
  BY_CHECKS: 'BY_CHECKS',
  BY_INCIDENTS: 'BY_INCIDENTS',
};
